module.exports = __webpack_public_path__ + "img/melson2_white_with_company_name.fc9a2338.png";